import axios from 'axios'

// const baseDomain = 'https://api.staging.bniservicerating.com'
const baseDomain = 'https://api.bniservicerating.com'
// const baseDomain = 'http://api.sadmin.bni.grvty.xyz'
// const baseDomain = 'http://localhost:8000'
const baseURL = `${baseDomain}/v1`
// const apiKey = '1234567890'
const apiKey = 'ZE92pkHlV2gDoj5eddjAO21Zkz5Qxpnq'

export default axios.create({
    baseURL: baseURL,
    headers: {
        'x-api-key': apiKey
    }
}) 